// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NotFound_wrapper__3Vk-H","header":"NotFound_header__2az-z","img":"NotFound_img__2ZT3e","text":"NotFound_text__1sRvV","link":"NotFound_link__3d2BG"};